module.exports = __webpack_public_path__ + "static/media/weight.71f0c579.svg";